import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getAllDistrictBihar } from '../../../services/monthlyAttendanceService';
import {
    getSubDivisionsByDistrictId,
    updateSubDivision,

} from '../../../services/godownLatLongService';
import { capitalizeFirstLetter } from '../../../utils/validations';
import './SubDivisionUpdateForGodown.css';
import { useNavigate } from 'react-router-dom';

const SubDivisionUpdateForGodown = () => {
    const [districtOptions, setDistrictOptions] = useState([]);
    const [districtId, setDistrictId] = useState(null);
    const [subDivisionData, setSubDivisionData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editingSubDivisionId, setEditingSubDivisionId] = useState(null);
    const [editPayload, setEditPayload] = useState({
        subDivisionName: '',
        subDivisionUid: '',
        districtId: null
    });
    const navigate = useNavigate();

    // Fetch Districts
    useEffect(() => {
        const fetchDistricts = async () => {
            try {
                const data = await getAllDistrictBihar();
                setDistrictOptions(data.map(item => ({
                    value: item.districtId,
                    label: item.districtName,
                })));
            } catch (err) {
                console.error('Error fetching districts:', err);
            }
        };
        fetchDistricts();
    }, []);

    // Fetch SubDivisions when district changes
    const fetchSubDivisions = async (districtId) => {
        if (!districtId) return;
        setLoading(true);
        try {
            const data = await getSubDivisionsByDistrictId(districtId);
            setSubDivisionData(data || []);
        } catch (error) {
            console.error('Error fetching subdivisions:', error);
            alert("Failed to fetch subdivisions.");
            setSubDivisionData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleFetch = () => {
        if (!districtId) {
            alert("Please select a district!");
            return;
        }
        fetchSubDivisions(districtId);
    };

    const handleReset = () => {
        setDistrictId(null);
        setSubDivisionData([]);
        setEditingSubDivisionId(null);
        setEditPayload({
            subDivisionName: '',
            subDivisionUid: '',
            districtId: null
        });
    };

    const gotoCreation = () => {
        navigate("/subDivisionForGodown");
    };

    const handleEditClick = (subDivision) => {
        setEditingSubDivisionId(subDivision.id);
        setEditPayload({
            subDivisionName: subDivision.subDivisionName || '',
            subDivisionUid: subDivision.subDivisionUid || '',
            districtId: subDivision.district?.districtId || districtId
        });
    };

    const handleTableInputChange = (e) => {
        const { name, value } = e.target;
        setEditPayload(prev => ({
            ...prev,
            [name]: name === 'subDivisionUid' ? parseInt(value) || '' : value
        }));
    };

    const handleUpdateSubDivision = async (id) => {
        if (!editPayload.subDivisionName || !editPayload.subDivisionUid) {
            alert("SubDivision Name and UID are required!");
            return;
        }

        try {
            setLoading(true);
            const payload = {
                subDivisionName: editPayload.subDivisionName,
                district: {
                    districtId: parseInt(editPayload.districtId)
                }
            };

            await updateSubDivision(id, payload);
            alert(`SubDivision updated successfully!`);

            setEditingSubDivisionId(null);
            fetchSubDivisions(districtId); // Refresh table
        } catch (error) {
            console.error("Update failed:", error);
            alert("Failed to update subdivision.");
        } finally {
            setLoading(false);
        }
    };



    return (
        <div className="Update-sub-block-container">
            <div className="Update-sub-form-card">
                <h2 className="Update-sub-form-title">Update SubDivision</h2>
                <div className='Update-sub-navigate-btn'>
                    <button type='button' className='Update-sub-godown-btn-navigate' onClick={gotoCreation}>
                        Add SubDivision
                    </button>
                </div>
                <div className="Update-sub-form-grid">
                    <div className="Update-sub-input-group">
                        <div className={`Update-sub-custom-select ${districtId ? 'has-value' : ''}`}>
                            <Select
                                classNamePrefix="select"
                                placeholder=" "
                                isClearable
                                options={districtOptions}
                                value={districtOptions.find(opt => opt.value === districtId) || null}
                                onChange={(opt) => setDistrictId(opt?.value || null)}
                            />
                        </div>
                        <label><span className="Update-sub-required">*</span> District</label>
                    </div>

                    <div className="Update-sub-button-group">
                        <button
                            className="Update-sub-btn Update-sub-btn-primary"
                            onClick={handleFetch}
                            disabled={loading || !districtId}
                        >
                            {loading ? 'Fetching...' : 'Fetch SubDivisions'}
                        </button>
                        <button
                            className="Update-sub-btn Update-sub-btn-secondary"
                            onClick={handleReset}
                        >
                            Reset
                        </button>
                    </div>
                </div>
            </div>

            <div>
                {subDivisionData.length > 0 && (
                    <div style={{ marginTop: '2.5rem' }}>
                        <h3>SubDivision List</h3>
                        <table className="Update-sub-godown-table">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>District Name</th>
                                    <th>SubDivision UID</th>
                                    <th>SubDivision Name</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {subDivisionData.map((subDivision, index) => (
                                    <tr key={subDivision.id || index}>
                                        <td>{index + 1}</td>
                                        <td>{subDivision.district?.districtName || 'N/A'}</td>
                                        <td>
                                            {editingSubDivisionId === subDivision.id ? (
                                                <input
                                                    type="number"
                                                    name="subDivisionUid"
                                                    className="Update-sub-table-input-edit"
                                                    value={editPayload.subDivisionUid}
                                                    onChange={handleTableInputChange}
                                                />
                                            ) : (
                                                subDivision.subDivisionUid || 'N/A'
                                            )}
                                        </td>
                                        <td>
                                            {editingSubDivisionId === subDivision.id ? (
                                                <input
                                                    type="text"
                                                    name="subDivisionName"
                                                    className="Update-sub-table-input-edit"
                                                    value={editPayload.subDivisionName}
                                                    onChange={handleTableInputChange}
                                                />
                                            ) : (
                                                capitalizeFirstLetter(subDivision.subDivisionName) || 'N/A'
                                            )}
                                        </td>
                                        <td>
                                            {editingSubDivisionId === subDivision.id ? (
                                                <div className="Update-sub-action-buttons-flex">
                                                    <button
                                                        className="Update-sub-btn Update-sub-btn-primary"
                                                        onClick={() => handleUpdateSubDivision(subDivision.id)}
                                                        disabled={loading}
                                                    >
                                                        {loading ? '...' : 'Save'}
                                                    </button>
                                                    <button
                                                        className="Update-sub-btn Update-sub-btn-secondary"
                                                        onClick={() => setEditingSubDivisionId(null)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className="Update-sub-action-buttons-flex">
                                                    <button
                                                        className="Update-sub-btn Update-sub-btn-primary"
                                                        onClick={() => handleEditClick(subDivision)}
                                                    >
                                                        Edit
                                                    </button>

                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {subDivisionData.length === 0 && districtId && !loading && (
                    <p style={{ textAlign: 'center', marginTop: '2rem', color: '#666' }}>
                        No subdivisions found for the selected district.
                    </p>
                )}
            </div>
        </div>
    );
};

export default SubDivisionUpdateForGodown;